import { useContext, useEffect, useRef, useState } from 'react'
import { Navigate, useSearchParams, useLocation } from 'react-router-dom'
import { SystemContext } from '../../shared/context'
import { saveLS } from '../../helper/LocalStorage'
import LoadingPulse from '../../components/Loading/LoadingPulse'
import useRequest from '../../hooks/useRequest'
import { LogoutHandler } from '../../helper/Request'
import logRedirect from '../../helper/RedirectLogger'
import PropTypes from 'prop-types'

const LoggedNavigate = ({ to, replace }) => {
	const location = useLocation()

	useEffect(() => {
		logRedirect('RedirectHandler', {
			from: location.pathname + location.search,
			to,
			replace,
			action: 'React Router Navigate to /',
		})
	}, [location, to, replace])

	return <Navigate to={to} replace={replace} />
}

const redirectUri = window.location.origin + '/login/target'
const clientId = process.env.REACT_APP_CLIENT_ID

const RedirectHandler = () => {
	const [searchParams] = useSearchParams()
	const { LoginHandler } = useContext(SystemContext)
	const { Request, RequestHeader } = useRequest()
	const [loading, setLoading] = useState(true)
	const hasProcessedCallback = useRef(false)

	useEffect(() => {
		if (hasProcessedCallback.current) {
			return
		}

		hasProcessedCallback.current = true
		const code = searchParams.get('code')

		logRedirect('RedirectHandler', {
			hasCode: !!code,
			action: 'Processing SSO callback',
			currentPath: window.location.pathname,
			currentSearch: window.location.search,
			referrer: document.referrer,
		})

		const start = async () => {
			const codeVerifier = sessionStorage.getItem('pkce_code_verifier')
			const authUrl = `/Authentication/Token?grant_type=authorization_code&code=${code}&client_id=${clientId}&redirect_uri=${redirectUri}&code_verifier=${codeVerifier}`

			logRedirect('RedirectHandler', {
				action: 'Requesting token from SSO callback',
			})

			const tokenRequest = await Request(authUrl, RequestHeader(null, 'POST'))

			if (!tokenRequest.ok) {
				logRedirect('RedirectHandler', {
					action: 'Token request failed, logging out',
				})
				LogoutHandler()
				return
			}

			saveLS('auth', tokenRequest.data)
			await LoginHandler(tokenRequest.data)

			logRedirect('RedirectHandler', {
				action: 'Login successful, redirecting to /',
			})

			setLoading(false)
		}

		start()
	}, [searchParams, LoginHandler, Request, RequestHeader])

	return (
		<LoadingPulse isFullScreen visible={loading} className="items-center w-full">
			<LoggedNavigate to="/" />
		</LoadingPulse>
	)
}

LoggedNavigate.propTypes = {
	to: PropTypes.string.isRequired,
	replace: PropTypes.bool,
}

export default RedirectHandler
